import globalForm from "../../apis/globalForm";

export default {
  getglobalform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await globalForm.getglobalform(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  addglobalform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await globalForm.addglobalform(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editglobalform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await globalForm.editglobalform(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteglobalform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await globalForm.deleteglobalform(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
